// Função que troca a imagem dentro do .dp-topbar-logo
function trocarLogo(el) {
    const img = el.querySelector('img');
    if (img) {
      img.src = "./wp-content/themes/minerva-foods/includes/images/minerva-foods-footer.png"; // URL da nova logo
      img.srcset = ""; // opcional: limpa srcset se tiver
    }
  }
  
  // Observer para detectar criação de elementos
  const observer = new MutationObserver(() => {
    const logo = document.querySelector('.dp-topbar-logo');
    if (logo) {
      trocarLogo(logo);
    }
  });
  
  // Começa a observar mudanças no body
  observer.observe(document.body, { childList: true, subtree: true });
